import {useMutation} from "@tanstack/react-query";
import {editCustomerOfferNoteMutationOptions} from "./edit-customer-offer-note.mutation-options";

export function useEditCustomerOfferNote(id: string, noteId: number) {
  return useMutation(editCustomerOfferNoteMutationOptions(id, noteId));
}
